import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Colors } from 'constants/colors'
import { DRAWER_WIDTH } from 'components/SideDrawer/SideDrawerElements'

const Root = styled(Box)({
  display: 'flex',
  minHeight: '100vh',
  overflow: 'hidden',
})

const ContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'isMobile',
})<{ open?: boolean; isMobile?: boolean }>(({ open, isMobile }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  marginLeft: isMobile ? 0 : (open ? `${DRAWER_WIDTH}px` : '64px'),
  transition: 'margin-left 0.3s ease',
  background: Colors.backgroundDarkGray,
  minHeight: '100vh',
  width: isMobile ? '100%' : 'auto',
  maxWidth: '100vw',
  overflowX: 'hidden',
}))

const Content = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flexGrow: 1,
  margin: '20px',
  '@media (max-width: 900px)': {
    margin: '12px',
  },
})

export const MainLayoutElements = {
  Root,
  ContentWrapper,
  Content,
}